// API'den gelen veriler için boş fallback
export const octoberCMSData = {
  siteSettings: {},
  vehicles: [],
  services: [],
  contact: {},
  socialMedia: {}
};

// OctoberCMS API'den veri alma
export const fetchOctoberCMSData = () => {
  console.log('API çağrısı başlatılıyor...');
  
  return new Promise((resolve, reject) => {
    // Environment variable'dan API URL'yi al
    const apiUrl = process.env.REACT_APP_API_URL || 'https://agaclandirmaseferberligi.com/api/data-v2';
    console.log('Fetching from:', apiUrl);
    
    fetch(apiUrl)
      .then(response => {
        console.log('API Response status:', response.status);
        if (response.ok) {
          return response.text();
        }
        throw new Error(`API yanıt vermedi: ${response.status}`);
      })
      .then(responseText => {
        // JSON'daki kontrol karakterlerini temizle
        const cleanedText = responseText.replace(/[\x00-\x1F\x7F]/g, '');
        
        try {
          const apiData = JSON.parse(cleanedText);
          console.log('Toyota API\'den veriler alındı:', apiData);
          
          // API verilerini fallback verilerle birleştir
          const mergedData = mergeWithFallback(apiData);
          resolve(mergedData);
        } catch (parseError) {
          console.error('JSON parse hatası:', parseError);
          console.log('Problematik JSON (ilk 1000 karakter):', responseText.substring(0, 1000));
          throw parseError;
        }
      })
      .catch(error => {
        console.error('Toyota API hatası:', error);
        // API çalışmazsa boş veri döndür
        resolve({
          siteSettings: {},
          sliders: [],
          trees: [],
          goals: [],
          videos: [],
          gallery: [],
          vehicles: [],
          services: [],
          faqs: [],
          contact: {},
          socialMedia: {}
        });
      });
  });
};

// API verilerini doğrudan kullan
function mergeWithFallback(apiData) {
  return {
    siteSettings: apiData.siteSettings || {},
    sliders: apiData.sliders || [],
    trees: apiData.trees || [],
    goals: apiData.goals || [],
    videos: apiData.videos || [],
    gallery: apiData.gallery || [],
    vehicles: apiData.vehicles || [],
    services: apiData.services || [],
    faqs: apiData.faqs || [],
    contact: apiData.contact || {},
    socialMedia: apiData.socialMedia || {}
  };
}
